// TODO : fetch this from the backend
export const apPhasesList = {
    ['dateProposed']: 'propositionServices',
    ['dateArbitrated']: 'arbitrage',
    ['dateVoted']: 'supplementaryBudget',
    ['dateSupp']: 'vote',
};
